import Swiper from 'swiper';
import ww from '../globals.js';

$(document).ready(() => {

  $('.btn-open-nav-menu').on('click', () => {
    $('.nav')
	    .addClass('open-nav open-mob-window');
    $('.body')
      .addClass('overflow-mobile');
  });

  $('.btn-open-search').on('click', () => {
    $('.nav')
      .addClass('open-search open-mob-window');
    $('.body')
      .addClass('overflow-mobile');
    $('.open-search .input')
      .attr('placeholder', 'Поиск...');
  });

  $('.close-mob-menu').on('click', () => {
    $('.nav')
	    .removeClass('open-nav open-mob-window');
    $('.body')
      .removeClass('overflow-mobile');
    $('.nav')
	    .removeClass('open-search open-mob-window');
  });
}); 
